/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRectangleSelect = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M2 7.333V5h2.222v2H4v.333zM10.889 5H6.444v2h4.445zm2.222 0v2h4.445V5zm6.667 0v2H20v.333h2V5zM22 9.667h-2v4.666h2zm0 7h-2V17h-.222v2H22zM17.556 19v-2H13.11v2zm-6.667 0v-2H6.444v2zm-6.667 0v-2H4v-.333H2V19zM2 14.333h2V9.667H2z" clipRule="evenodd" /></svg>;
export default SvgRectangleSelect;